import { useViewContext } from "@editor-providers";
import { useIsStatic } from "@library/components";
import {
  COMBO_ANIM_BASE_OPACITY,
  COMBO_ANIM_DEFAULT_DIRECTION,
  COMBO_ANIM_DEFAULT_SPEED,
  COMBO_ANIM_DEFAULT_TYPE,
} from "@library/constants";
import { isElementInDisabledContainer, useAnimation } from "@library/shared";
import type { RefObject } from "react";
import type { ComboAnimationType, ComboSettingsType } from "../types";

export const useAnimationHandler = ({
  ref,
  containerRef,
  settings,
}: {
  ref: RefObject<HTMLDivElement>;
  containerRef: RefObject<HTMLDivElement>;
  settings: ComboSettingsType;
}) => {
  "use no memo";
  const { view } = useViewContext();
  const isPdf = view === "pdf";
  const isTimeline = settings.name === "VTimeline";
  const isStatic = useIsStatic();
  let isAnimationDisabled = false;
  if (ref.current) {
    isAnimationDisabled = isElementInDisabledContainer(
      ref.current,
      !!settings.isAnimationActive,
    );
  }

  let animation;
  if (
    !isTimeline &&
    !isPdf &&
    !isStatic &&
    settings.isAnimationActive &&
    !isAnimationDisabled
  ) {
    const {
      animationType = COMBO_ANIM_DEFAULT_TYPE,
      animationSpeed = COMBO_ANIM_DEFAULT_SPEED,
      animationBaseOpacity = COMBO_ANIM_BASE_OPACITY,
      animationDirection = COMBO_ANIM_DEFAULT_DIRECTION,
    } = settings;

    animation = {
      type: animationType,
      speed: animationSpeed,
      baseOpacity: animationBaseOpacity,
      direction: animationDirection,
    } as ComboAnimationType;
  }

  useAnimation({
    ref: containerRef,
    type: animation?.type,
    speed: animation?.speed,
    direction: animation?.direction,
    animate: !!animation,
    name: settings.name,
  });

  return { animation };
};
